module.exports = __webpack_public_path__ + "static/media/cryptoToCoin.a7458553.png";